





























import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, LineDrawerPropertyEditableMixin, PainterPropertyEditableMixin } from "./mixins";
import { DrawableItemEditorMixin } from "../mixins";
import LineStyleEditor from "../../../drawing/LineStyleEditor.vue";
import PaintStyleEditor from "../../../drawing/PaintStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";

@Component({
  components: {
    lineStyleEditor: LineStyleEditor,
    paintStyleEditor: PaintStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
  },
})
export default class TexturedShapePropertyEditor extends Mixins(PropertyEditableMixin, DrawableItemEditorMixin, DrawerPropertyEditableMixin, LineDrawerPropertyEditableMixin, PainterPropertyEditableMixin) {
}
